import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './DayAheadTradingUnderConstructionBanner.module.less'

export function DayAheadTradingUnderConstructionBanner(): ReactNode {
  const { t } = useTranslation()

  return (
    <div className={styles.DayAheadTradingUnderConstructionBanner} role="status">
      {t('This module is under construction and will be built incrementally.')}
    </div>
  )
}
